export {default} from './InactiveClientsReport';
